import { render, staticRenderFns } from "./none.vue?vue&type=template&id=28db71c0&scoped=true"
import script from "./none.vue?vue&type=script&lang=js"
export * from "./none.vue?vue&type=script&lang=js"
import style0 from "./none.vue?vue&type=style&index=0&id=28db71c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28db71c0",
  null
  
)

export default component.exports